import { BreadcrumbController } from './breadcrumb.controller';
import template from './breadcrumb.html';

export const breadcrumbComponent = {
  name: 'breadcrumb',
  restrict: 'E',
  template,
  controller: BreadcrumbController,
  controllerAs: 'vm',
  bindings: {
    steps: '<',
    currentStep: '<',
    template: '@'
  }
};
